import { RootState } from '../../store';

export const getErrorsSelector = (state: RootState) => state?.categoryReducer?.errors;
